const formatTimestampToRelativeTime = (isoString) => {
  if (!isoString) return "";

  const date = new Date(isoString);
  if (isNaN(date.getTime())) return "";

  const now = new Date();
  const diffMs = now - date;
  const minutes = Math.floor(diffMs / 60000);

  // Normalize dates to local midnight for accurate comparison
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);

  const startOfNotificationDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const isToday = startOfNotificationDay.getTime() === startOfToday.getTime();
  const isYesterday = startOfNotificationDay.getTime() === startOfYesterday.getTime();

  const formatTime = (d) => {
    let h = d.getHours();
    const m = d.getMinutes();
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${m.toString().padStart(2, "0")} ${ampm}`;
  };

  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min${minutes > 1 ? "s" : ""} ago`;

  if (isToday) return `Today, ${formatTime(date)}`;
  if (isYesterday) return `Yesterday, ${formatTime(date)}`;

  // Older dates
  return date.toLocaleDateString();
};

// notificationUtils.js (no React import)

export const NOTIFICATION_TYPE = {
  ASSIGNED: 1,
  MESSAGE: 2,
  MISSED_CALL: 3,
};

const NOTIFICATION_STATUS = {
  UNREAD: { value: 0, label: "Unread" },
  READ: { value: 1, label: "Read" },
};

const NOTIFICATION_ICON_CLASS = {
  [NOTIFICATION_TYPE?.ASSIGNED]: "actionIconsSprite-2 assignedNotificationIcon",
  [NOTIFICATION_TYPE?.MESSAGE]: "actionIconsSprite-2 messageNotificationIcon",
  [NOTIFICATION_TYPE?.MISSED_CALL]: "actionIconsSprite-2 missedCallNotificationIcon",
};

const DEFAULT_ICON_CLASS = "actionIconsSprite-2 messageNotificationIcon";

const getNotificationIconClassName = (typeNumber) => NOTIFICATION_ICON_CLASS[typeNumber] ?? DEFAULT_ICON_CLASS;

const parseNotificationContent = (notification) => {
  if (!notification) return { title: "", subtitle: "" };

  const { notificationContent } = notification;

  if (!notificationContent) {
    return { title: "Notification", subtitle: "" };
  }

  try {
    const parsed = JSON.parse(notificationContent);
    const title = parsed?.title;
    const body = parsed?.body;
    return {
      title: title,
      subtitle: body,
    };
  } catch (e) {
    console.error("Error parsing notification content:", e);
  }

  // Fallback for missed calls
  if (notification?.type === NOTIFICATION_TYPE?.MISSED_CALL) {
    return {
      title: notificationContent,
      subtitle: "View the call log and reconnect with the customer.",
    };
  }

  return {
    title: notificationContent,
    subtitle: "",
  };
};

const constructDeepLink = (notification, location) => {
  if (!notification) return null;
  if (notification?.type === NOTIFICATION_TYPE.MISSED_CALL.value) {
    return `/voice/history${location.search}`;
  }
  const conversationOrContactId = notification?.associatedModuleDetails?.conversationId;

  return `/inbox/${conversationOrContactId ?? ""}${location.search}`;
};

export { formatTimestampToRelativeTime, getNotificationIconClassName, parseNotificationContent, NOTIFICATION_STATUS, constructDeepLink };
